module.exports = __webpack_public_path__ + "static/media/background.a7a5272c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/background.png
// module id = 751
// module chunks = 0